import { Component, TemplateRef, ViewChild } from "@angular/core";
import { UiDrawerService } from "@webapp/ui/drawer/services/drawer.service";
import { DrawerRef } from "@webapp/ui/drawer/abstracts/drawer-ref";
import { TestDrawerComponent } from "@webapp/examples/example-drawer/test-drawer-component/test-drawer.component";
@Component({
  selector: "gh-example-drawer-component",
  templateUrl: "./example-drawer.component.html",
  styleUrls: [],
})
export class ExampleDrawerComponent {
  @ViewChild("drawerTemplate", { static: false }) public drawerTemplate?: TemplateRef<{
    $implicit: { value: string };
    drawerRef: DrawerRef<string>;
  }>;
  public value = "Test Display Variable";

  public constructor(private drawerService: UiDrawerService) {}

  public openTemplate(): void {
    const drawerRef = this.drawerService.create({
      uiTitle: "Template",
      uiFooter: "Footer",
      uiContent: this.drawerTemplate,
      uiContentParams: {
        value: this.value,
      },
    });

    drawerRef.afterOpen.subscribe(() => {
      // eslint-disable-next-line no-console
      console.log("Drawer(Template) open");
    });

    drawerRef.afterClose.subscribe(() => {
      // eslint-disable-next-line no-console
      console.log("Drawer(Template) close");
    });
  }

  public openComponent(): void {
    const drawerRef = this.drawerService.create<TestDrawerComponent, { value: string }, string>({
      uiTitle: "Component",
      uiFooter: "Footer",
      uiWidth: "50%",
      uiContent: TestDrawerComponent,
      uiContentParams: {
        testData: "TestInputData",
      },
    });

    drawerRef.afterOpen.subscribe(() => {
      // eslint-disable-next-line no-console
      console.log("Drawer(Component) open");
    });

    drawerRef.afterClose.subscribe((data) => {
      // eslint-disable-next-line no-console
      console.log(data);
    });
  }
}
